import { useQuery } from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import {
  getTagGroup,
  type TagGroupResponse,
} from '@hungryroot/rest/api/v2/tag_groups/[id]/get';
import { tagGroups, type TagGroups } from '@hungryroot/tags';

type Tag = TagGroupResponse['tags'][number];
export { tagGroups, type Tag };

function key(tagGroupId: number) {
  return ['tag group', tagGroupId];
}

export function useTagGroup(
  tagGroupId: TagGroups,
  options: { enabled?: boolean } = {}
) {
  const tagGroupKey = key(tagGroupId);
  return useQuery({
    queryKey: tagGroupKey,
    queryFn: async () => {
      const resp = await getTagGroup(tagGroupId);

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp.data, null, 2));
      }

      return resp.data;
    },
    ...options,
  });
}
